import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import { useLog } from '@/hooks/useLog';
import { commentsApi, useSaveCommentMutation } from '@/services/comments';
import { lessonsApi } from '@/services/lesson';
import styled, { css, StyledProp } from '@/styled';

import ListComment from './ListComment';

const Comments = ({ className }: StyledProp) => {
  const [text, setText] = useState('');
  const { id } = useParams();
  const [comment, { isLoading }] = useSaveCommentMutation();
  const { data: lesson } = lessonsApi.endpoints.getLessons.useQueryState(id);
  const [reloadList] = commentsApi.endpoints.getComments.useLazyQuerySubscription();
  const { activity } = useLog();

  const handleComment = () => {
    comment({ lessonId: id, comment: text })
      .then(() => {
        setText('');
        message.success('Comentário enviado com sucesso');
        reloadList({ lessonId: id, params: { page: 1, ownComments: true } });
        activity('commented', {
          message: `Comentou na aula ${lesson.title}`,
          courseHash: lesson.hash_course,
          lessonId: lesson.id
        });
      })
      .catch(() => {
        message.error('Ocorreu um erro ao enviar o comentário');
      });
  };
  const textMinLength = 2;
  return (
    <div className={className}>
      <div className='action'>
        <TextArea
          size='large'
          rows={3}
          placeholder='Insira seu comentário aqui'
          value={text}
          onChange={e => setText(e?.target?.value)}
          minLength={textMinLength}
          maxLength={5000}
        />
        <Button
          disabled={text.trim().length < textMinLength || isLoading}
          type='primary'
          size='large'
          onClick={handleComment}
          loading={isLoading}
        >
          Comentar
        </Button>
      </div>
      <ListComment />
    </div>
  );
};

export default styled(Comments)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    .action {
      display: flex;
      gap: ${theme.space.pxToRem(16)};
    }

    textarea {
      resize: vertical;
    }
  `
);
